<template>
  <div id="container">
    <div
      v-if="!mobile"
      class="q-pa-xs items-center justify-center row col-12"
      id="desktop"
    >
      <main class="base">
        <header class="row headerBase">
          <q-img
            v-if="$store.state.autenticacao.logo.logoImpressao"
            :src="$store.state.autenticacao.logo.logoImpressao"
            alt="Logo"
            class="logo q-pl-sm"
            fit="contain"
            crossorigin="*"
          />
          <q-img
            v-else
            fit="contain"
            src="../../../assets/MULTPEX_VETOR.png"
            alt="Acciona Logo"
            class="logo q-pl-sm"
            crossorigin="*"
          />

          <p class="text-h6 text-bold q-pa-md titulo-ficha">DADOS PICKING</p>
        </header>

        <div class="row data1">
          <div
            style="width: 25%"
            class="q-pl-sm borderleft text-bold row items-center"
          >
            <p>
              Numero Picking:
              <span class="q-ml-sm" style="font-weight: normal">
                {{ dadosCabecalho?.numero }}</span
              >
            </p>
          </div>
          <div style="width: 25%" class="q-pl-sm text-bold row items-center">
            <p>
              Unidade Origem:
              <span style="font-weight: normal">
                {{ dadosCabecalho?.unidadeNomeOrigem }}</span
              >
            </p>
          </div>
          <div
            style="width: 25%"
            class="q-pl-sm col text-bold row items-center"
          >
            <p>
              Unidade Destino:
              <span style="font-weight: normal">
                {{ dadosCabecalho?.unidadeNomeDestino }}</span
              >
            </p>
          </div>
          <div
            style="width: 25%"
            class="q-pl-sm col text-bold row items-center"
          >
            <p>
              Data Criação:
              <span style="font-weight: normal">{{
                dadosCabecalho?.dataCriacao
                  ?.split(" ")[0]
                  ?.split("-")
                  ?.reverse()
                  ?.join("/")
              }}</span>
            </p>
          </div>
        </div>
        <div style="border-top: 1px solid black" class="row data1">
          <div
            style="width: 25%"
            class="q-pl-sm borderleft text-bold row items-center"
          >
            <p>
              Data Envio:
              <span style="font-weight: normal">{{
                dadosCabecalho?.dataEnvio
                  ?.split(" ")[0]
                  ?.split("-")
                  ?.reverse()
                  ?.join("/")
              }}</span>
            </p>
          </div>
          <div style="width: 25%" class="q-pl-sm text-bold row items-center">
            <p>
              Data Recebimento Listagem:
              <span style="font-weight: normal">
                {{
                  dadosCabecalho?.dataRecebimento
                    ?.split(" ")[0]
                    ?.split("-")
                    ?.reverse()
                    ?.join("/")
                }}
              </span>
            </p>
          </div>
          <div
            style="width: 25%"
            class="q-pl-sm col text-bold row items-center"
          >
            <div class="row">
              Transportador:
              <div class="q-ml-sm">
                {{ dadosCabecalho?.usuarioTransportador?.name }}
              </div>
            </div>
          </div>
          <div
            style="width: 25%"
            class="q-pl-sm col text-bold row items-center"
          >
            <p>
              Solicitante:
              <span style="font-weight: normal">{{
                dadosCabecalho?.usuarioSolicitante?.name
              }}</span>
            </p>
          </div>
        </div>
        <div style="border-top: 1px solid black" class="row data1">
          <div
            style="width: 50%"
            class="q-pl-sm col text-bold row items-center"
          >
            <div style="align-items: center" class="row">
              Separador:
              <div class="q-ml-sm">
                {{ dadosCabecalho?.usuarioSeparador?.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="row data2 border-botom">
          <div class="row DESCRIÇÃODOMATERIAL text-bold borderleft">
            <p style="width: 12.5%" class="row justify-center">
              Numero Requisição
            </p>

            <p style="width: 12.5%" class="row justify-center codigo3">
              Nome Colaborador
            </p>
            <p style="width: 12.5%" class="row justify-center codigo3">
              Matricula Colaborador
            </p>
            <p style="width: 12.5%" class="row justify-center codigo3">
              Codigo Material
            </p>
            <p style="width: 12.5%" class="row justify-center codigo3">
              Descrição Material
            </p>
            <p style="width: 12.5%" class="row justify-center codigo3">
              Localização Material
            </p>
            <p style="width: 12.5%" class="row justify-center codigo3">
              Quantidade Solicitada
            </p>
            <p style="width: 12.5%" class="row justify-center codigo3">
              Quantidade Atendida
            </p>
          </div>
        </div>

        <div
          class="data3 row border-botom"
          v-for="(dadoPicking, index) in dadosTabela"
          :key="index"
          :class="{ quebra: index == 7 || (index - 7) % 15 == 0 }"
        >
          <div
            style="
              width: 12.5%;
              align-items: center;
              border-right: 1px solid black;
            "
            class="row justify-center"
          >
            {{ dadoPicking?.voucherId }}
          </div>
          <div
            style="
              width: 12.5%;
              align-items: center;
              border-right: 1px solid black;
            "
            class="row justify-center"
          >
            {{ dadoPicking?.detalhesProduto?.solicitanteVoucher?.nome }}
          </div>
          <div
            style="
              width: 12.5%;
              align-items: center;
              border-right: 1px solid black;
            "
            class="row justify-center"
          >
            {{ dadoPicking?.detalhesProduto?.solicitanteVoucher?.matricula }}
          </div>
          <div
            style="
              width: 12.5%;
              align-items: center;
              border-right: 1px solid black;
            "
            class="row justify-center"
          >
            {{ dadoPicking?.detalhesProduto?.codigo }}
          </div>

          <div
            style="
              width: 12.5%;
              align-items: center;
              border-right: 1px solid black;
              text-align: center;
            "
            class="row justify-center"
          >
            {{ dadoPicking?.detalhesProduto?.nome }}
          </div>
          <div
            style="
              width: 12.5%;
              align-items: center;
              border-right: 1px solid black;
            "
            class="row justify-center"
          >
            {{ dadoPicking?.detalhesProduto?.localizacao }}
          </div>
          <div
            style="
              width: 12.5%;
              align-items: center;
              border-right: 1px solid black;
            "
            class="row justify-center"
          >
            {{ dadoPicking?.quantidadeOriginalTotal }}
          </div>
          <div
            style="width: 12.5%; align-items: center"
            class="row justify-center"
          >
            {{ dadoPicking?.quantidadeAtendidaTotal }}
          </div>
        </div>
      </main>
    </div>
    <div style="overflow: scroll" id="mobile">
      <main id="base-mobile" class="base q-ma-md">
        <header class="row headerBase">
          <q-img
            v-if="$store.state.autenticacao.logo.logoImpressao"
            :src="$store.state.autenticacao.logo.logoImpressao"
            alt="Multpex Logo"
            class="logo q-pl-sm"
            crossorigin="*"
            fit="contain"
          />
          <q-img
            v-else
            src="../../../assets/MULTPEX_VETOR.png"
            alt="Acciona Logo"
            fit="contain"
            class="logo q-pl-sm"
          />

          <p class="text-h6 text-bold q-pa-md titulo-ficha">
            LISTA DE PRESENÇA
          </p>
        </header>
        <div class="row justify-center subHeader"></div>

        <div class="row q-pl-sm justify-center descricao"></div>
        <div class="row data1 border-botom">
          <p class="q-pl-sm nome text-bold row items-center">
            NOME: {{ dadosUsuario ? dadosUsuario.nome : "" }}
          </p>
          <p class="q-pl-sm função text-bold row items-center">
            MATRICULA: {{ dadosUsuario ? dadosUsuario.id : "" }}
          </p>
        </div>
        <div class="row data1"></div>
        <div class="row data2 border-botom">
          <div class="row column DESCRIÇÃODOMATERIAL borderleft">
            <p style="width: 50%" class="row codigo justify-center text-bold">
              CODIGO
            </p>
            <p class="row descricao2 justify-center text-bold">
              DESCRIÇÃO DO MATERIAL
            </p>
          </div>
          <div class="column col ENTREGA">
            <p class="row justify-center border-botom text-bold borderRight">
              ENTREGA
            </p>
            <div class="row">
              <div class="table1 borderRight">
                <p class="text text-bold">Nº DO PATRIMÔNIO</p>
              </div>

              <div class="table2 borderRight">
                <p class="text text-bold">ASSINATURA</p>
              </div>
              <div class="table3 borderRight">
                <p class="text text-bold">UNIDADE DE ENTREGA</p>
              </div>
              <div class="table4 borderRight">
                <p class="text text-bold">DATA ENTREGA</p>
              </div>
            </div>
          </div>
          <div class="column DEVOLUÇÃO">
            <p class="row justify-center border-botom text-bold">DEVOLUÇÃO</p>
            <div class="row">
              <div class="secondTable1 borderRight">
                <p class="text text-bold">Nº DO PATRIMÔNIO</p>
              </div>
              <div class="secondTable2 borderRight">
                <p class="text text-bold">ASSINATURA</p>
              </div>
              <div class="secondTable3 borderRight">
                <p class="text text-bold">DATA ENTREGA</p>
              </div>
              <div class="secondTable4">
                <p class="text text-bold">UNIDADE DEVOLUÇÃO</p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import { useQuasar } from "quasar";

export default {
  setup() {
    const $route = useRoute();
    const quasar = useQuasar();

    const store = useStore();
    const id = $route.params?.id ? $route.params?.id : null;
    const dadosUsuario = ref("");
    const dadosCabecalho = ref();
    const tabelas = ref([]);
    const funcionarioDado = ref({});
    const nome = ref("");
    const funcao = ref("");
    const registro = ref("");
    const dadosTabela = ref({ treinamentos: [] });
    let disable = ref(false);

    const realm = ref("");
    const quebras = ref([
      9, 22, 35, 48, 61, 74, 87, 100, 113, 126, 139, 152, 165, 178, 191,
    ]);
    const dadosFicha = ref({
      titulo: "",
      subtitulo: "",
      dizeres: "",
    });
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const getData = async () => {
      quasar.loading.show();
      try {
        store.dispatch("pdt/hiddenHeader", false);

        if (id.includes("-")) {
          let response = await store.dispatch(
            "pkg/getListagemPickingsAgrupado",
            {
              pickingUuid: id,
            }
          );

          dadosTabela.value = response.data?.result?.dados?.[0]?.itens;
          dadosCabecalho.value = response.data?.result?.dados?.[0];
        } else {
          let response = await store.dispatch(
            "pkg/getListagemPickingsAgrupado",
            {
              numero: id,
            }
          );

          dadosTabela.value = response.data?.result?.dados?.[0].itens;
          dadosCabecalho.value = response.data?.result?.dados?.[0];
        }
        quasar.loading.hide();
      } catch (error) {
        quasar.loading.hide();
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(() => {
      getData();
    });

    return {
      tabelas,
      nome,
      dadosCabecalho,
      funcao,
      registro,
      realm,
      quebras,
      disable,
      dadosFicha,
      dadosUsuario,

      dadosTabela,

      funcionarioDado,
      mobile,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

@page {
  size: A4 landscape;
}

.base {
  border: 1px solid black;
}

.base p {
  margin: 0px;
}

.data1 {
  font-size: 16px;
}

.headerBase {
  border-bottom: 1px solid black;
  display: flex;
}

.border-botom {
  border-bottom: 1px solid black;
}

.separador {
  height: 5px;
  border-bottom: 1px solid black;
}

.função {
  width: 65%;
}

.registro {
  width: 30%;
}

.data2 {
  border-top: 1px solid black;
}

.DESCRIÇÃODOMATERIAL {
  width: 100%;
  height: 40px;
  font-size: 14px;
  text-align: center;
}

.DESCRIÇÃODOMATERIAL p {
  height: 100%;
  align-items: center;
  justify-content: center;
}

.ENTREGA {
  width: 35%;
}

.DEVOLUÇÃO {
  width: 30%;
}

.unidade-entrega {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}

.unidade-devolucao {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30%;
}

.borderRight {
  border-right: 1px solid black;
}

.text {
  text-align: center;
  word-wrap: break-word;
}

.table1 {
  display: flex;
  justify-content: center;
  width: 25%;
  align-items: center;
}

.table2 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}

.table3 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}

.codigo3 {
  border-left: 1px solid black;
  border-right: 1px solid black;
}

.table4 {
  display: flex;
  justify-content: center;
  width: 25%;
  align-items: center;
}

.biometria {
  height: 60px !important;
  width: 90px !important;
  object-fit: contain;
}
.secondTable1 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}

.secondTable2 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}

.secondTable3 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}

.secondTable4 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}
.border-top {
  border-top: 1px solid black;
}

.headerBase p {
  width: 79%;
  display: flex;
  justify-content: center;
}

.biometria {
  padding: 6px;

  width: 50px !important;
}

.subHeader {
  border-bottom: 1px solid black;
  font-weight: bolder;
}

.descricao {
  border-bottom: 1px solid black;
  height: 56px;
  align-items: center;
}

.data2 {
  font-size: 11px;
}
.nome {
  width: 100%;
}
.logo {
  margin-top: 5px;
  height: 50px;
  width: 180px;
}

.data3 {
  height: 50px;
}

.quebra {
  page-break-after: always;
}
@page {
  margin: 0.9mm;
  size: 290.7mm 210mm;
}
#desktop {
  display: block;
}
#mobile {
  display: none;
}

/* @media (max-width: 1000px) {
        .base p {
          font-size: 10px;
          margin: 0px;
          padding: 0px;
        }
      }
      @media (max-width: 800px) {
        .base p {
          font-size: 8px;
          margin: 0px;
          padding: 0px;
        }
      } */
@media (max-width: 600px) {
  /* #desktop {
          display: none;
        } */
  #mobile {
    display: block;
  }
}

@media print {
  .data1 {
    font-size: 12px;
  }
  .data2 {
    font-size: 10px;
  }

  .data3 {
    font-size: 8px;
  }
}
</style>
